import React from 'react';
import cls from 'classnames';
import Avatar from 'packages/common/components/Avatar';
type StepCardProps = {
  steps: {
    title: React.ReactNode;
    extra?: React.ReactNode;
  }[];
  avatar?: string;
  title?: React.ReactNode;
  className?: string;
};

const StepCard: React.FC<StepCardProps> = ({
  steps,
  avatar,
  title,
  className = ''
}) => <section className={cls(className, 'share-step-container background-color-BGPrimary px-20', avatar ? 'pt-40 pb-20' : 'py-20')}>
    {avatar && <section className="avatar-wrapper background-color-BGPrimary">
        <Avatar size="middle" src={avatar} style={{
      background: 'none'
    }} />
      </section>}

    {title && <section className="title-wrapper">{title}</section>}

    <section className="step-wrapper">
      {steps.map((item, index) => <section className="step-item" key={index}>
          <span className="icon H3-Bold">{index + 1}</span>
          <section className="step-item-content-wrapper">
            <header className="step-title">{item.title}</header>
            {item.extra}
          </section>
        </section>)}
    </section>

    <style jsx>{`
      .share-step-container {
        border-radius: 16px;
        position: relative;
      }

      .avatar-wrapper {
        position: absolute;
        top: 0;
        left: 50%;
        padding: 5px;
        border-radius: 50%;
        transform: translate(-50%, -50%);
      }

      .step-wrapper .step-item {
        display: flex;
        align-items: flex-start;
      }
      .step-wrapper .step-item + .step-item {
        margin-top: 20px;
      }
      .step-wrapper .step-item .icon {
        flex: none;
        width: 30px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        border-radius: 50%;
        background: linear-gradient(0deg, #fff1bf, #fff1bf),
          linear-gradient(189.4deg, #ffa901 0.63%, #fdff84 135.8%);
        box-shadow: inset 0px -6.35294px 4.23529px rgba(255, 255, 255, 0.37),
          inset 0px 12.7059px 0px rgba(255, 250, 239, 0.26);
        color: #983b07;
      }
      .step-wrapper .step-item .step-item-content-wrapper {
        flex: 1 1 auto;
        margin-inline-start: 14px;
        -webkit-margin-start: 14px;
      }
      .step-title {
        line-height: 30px;
      }
    `}</style>
  </section>;

export default StepCard;